import { useState } from "react";
import dynamic from "next/dynamic";
import MapLayout from "../Map/MapLayout";
import MapOverlay from "../Map/MapOverlay";
import MapOverlayList from "../Map/MapOverlayList";
import figureService from "../../lib/figure";
import FigureTile from "../Figure/FigureTile";
import MapOverlayGrid from "../Map/MapOverlayGrid";

const Map = dynamic(() => import("../Map/Map"), { ssr: false });

export default function PathsPage({ centers, figures }) {
  const [figuresData, setFiguresData] = useState(figures);
  const [lines, setLines] = useState({});

  const toggleFigure = (index) => {
    const clickedFigure = figuresData[index];
    const selected = !clickedFigure.selected;

    const newFiguresData = [
      ...figuresData.slice(0, index),
      {
        ...clickedFigure,
        selected,
      },
      ...figuresData.slice(index + 1, figuresData.length),
    ];

    const newLines = {
      ...lines,
    };

    if (selected && !newLines[index] && clickedFigure.stopsCoords.length > 0) {
      newLines[index] = {
        coords: clickedFigure.stopsCoords,
        className: "full-path",
        color: clickedFigure.color,
        index,
      };
    } else if (!selected && newLines[index]) {
      delete newLines[index];
    }

    setFiguresData(newFiguresData);
    setLines(newLines);
  };

  return (
    <MapLayout>
      <Map centers={centers} animatedPolylines={Object.values(lines)} />
      <MapOverlay className="right-0 h-full pt-3">
        <MapOverlayList>
          <MapOverlayGrid>
            {figuresData
              ? figuresData.map((figure) => {
                  const name = figure.title;
                  const portrait = figureService.getPortraitUrl(figure);
                  const alt = figureService.getPortraitAlt(figure);
                  const { slug, index, selected, color } = figure;

                  return (
                    <div
                      key={slug}
                      onClick={() => toggleFigure(index)}
                      className="cursor-pointer"
                      style={{ outline: selected ? `4px solid ${color}` : "none" }}
                    >
                      <FigureTile
                        name={name}
                        portrait={portrait}
                        alt={alt}
                        className={`h-full ${
                          selected ? "img-color" : "bg-deltaLight text-gray-700 img-gray"
                        } `}
                      />
                    </div>
                  );
                })
              : null}
          </MapOverlayGrid>
        </MapOverlayList>
      </MapOverlay>
    </MapLayout>
  );
}
